import { createContext, useReducer, useContext } from 'react'

export const MessageContext = createContext() 

export const messageReducer = (state, action) => {
    switch (action.type) {
        case 'SET_MESSAGE':
            return { messages: action.payload }
        case 'CREATE_MESSAGE':
            return { messages: [...state.messages, action.payload] }
        case 'UPDATE_MESSAGE':
            return { 
                messages: state.messages.map((msg) => 
                    msg._id === action.payload._id ? action.payload : msg
                ) 
            }
        case 'DELETE_MESSAGE':
            return { messages: state.messages.filter(u => u._id !== action.payload._id) }
        default:
            return state
    }
}

export const MessageContextProvider = ({children}) => {
    const [state, dispatchMessages] = useReducer(messageReducer, { messages: [] })
    return (
        <MessageContext.Provider value={{ ...state, dispatchMessages}}>
            { children }
        </MessageContext.Provider>
    )
}

export const useMessageContext = () => {
    const context = useContext(MessageContext)
    if(!context) throw Error('useMessageContext must be used inside an MessageContextProvider')
    return context
}
